export default __webpack_public_path__ + "static/media/express2.0911f0b6.svg";